import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import Observations from "../components/Observations";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
		groups: state.data.groups,
		firm: state.data.userInfo.firm,
		rank: state.data.userInfo.rank,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const ObservationContainer = connect(mapStateToProps, mapDispatchToProps)(Observations);

export default ObservationContainer;


// WEBPACK FOOTER //
// ./src/containers/ObservationContainer.js